import classNames from 'classnames';
import { ApsAppHeader, ApsGroup, ApsLanguageAvatar, ApsRoundButton } from 'UserExperience/portal-vnext';
import Logo from './Logo';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useState } from 'react';
import LanguageModal from './LanguageModal';


const Header = ({ brandLogoUrl, brandName }) => {

  const match = useRouteMatch({
    path: '/start',
    strict: false,
    sensitive: true
  });
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const backButtonClasses = classNames({
    'is-inactive': !!match
  });

  const goBack = () => {
    history.goBack();
  }

  const handleHomeClick = (e) => {
    if (!match) {
      history.push('/start');
    }
  }
  
  const [isLanguageModalVisible, setIsLanguageModalVisible] = useState(false);

  const showLanguageModal = () => {
    setIsLanguageModalVisible(true);
  };

  const handleLanguageModalOk = () => {
    setIsLanguageModalVisible(false);
  };

  const handleLanguageModalCancel = () => {
    setIsLanguageModalVisible(false);
  };  

  return (
    <ApsAppHeader headerTitle={t('global.title')}>
      <LanguageModal
        visible={isLanguageModalVisible}
        onOk={handleLanguageModalOk}
        onCancel={handleLanguageModalCancel}
      />
      <ApsRoundButton
        buttonContent="back"
        buttonLocation="topbar"
        className={backButtonClasses}
        alt="Go Back"
        onClick={goBack}
      />
      <Logo
        brandLogoUrl={brandLogoUrl}
        brandName={brandName}
      />
      <ApsGroup>
        <ApsLanguageAvatar
          avatarType={i18n.language}
          onClick={showLanguageModal}
          alt="Choose Language"
        />
        <ApsRoundButton
          buttonContent="home"
          buttonLocation="topbar"
          alt="Go to Start Page"
          onClick={handleHomeClick}
        />
      </ApsGroup>
    </ApsAppHeader>
  );
};

export default Header;